import { render } from "./Key-Value.vue?vue&type=template&id=f48ba10c"
import script from "./Key-Value.vue?vue&type=script&lang=js"
export * from "./Key-Value.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__